import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import {timeOut} from "../api/LoginApi";

const useSessionTimeout = (timeoutDuration = 900000) => { // 30 minutes default
    const navigate = useNavigate();
    const location = useLocation();
    let timeout;

    const resetTimeout = () => {
        if (timeout) clearTimeout(timeout);
        if (location.pathname !== '/') {
            timeout = setTimeout(() => {

                sessionStorage.clear();
                localStorage.clear()
                timeOut().then(
                    (response) => {
                        navigate('/', { state: { sessionExpired: true } });
                    }
                ).catch(reason => {
                    console.error("Error during session timeout API call:", reason);
                    navigate('/', { state: { sessionExpired: true } });
                })

            }, timeoutDuration);
        }
    };

    useEffect(() => {
        const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
        const resetTimer = () => resetTimeout();

        events.forEach(event => window.addEventListener(event, resetTimer));

        resetTimeout();

        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimer));
            if (timeout) clearTimeout(timeout);
        };
    }, [location.pathname]);

    return null;
};

export default useSessionTimeout;